import script from "./Clientes.vue?vue&type=script&setup=true&lang=js"
export * from "./Clientes.vue?vue&type=script&setup=true&lang=js"

import "./Clientes.vue?vue&type=style&index=0&id=3061401b&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3061401b"]])

export default __exports__